import React from "react";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";

export interface TopBarProps {
  title?: string;
  onToggleSidebar?: () => void;
  rightSlot?: React.ReactNode;
}

const TopBar: React.FC<TopBarProps> = ({ title, onToggleSidebar, rightSlot }) => {
  const { t } = useTranslation<"translation">();

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#000 !important", // negro absoluto
        color: "#fff !important", // texto e iconos blancos
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        variant="dense"
        disableGutters
        sx={{
          px: 2,
          minHeight: 48,
          display: "flex",
          alignItems: "center",
          color: "#fff !important", // asegura que Toolbar no herede otro color
        }}
      >
        {onToggleSidebar && (
          <IconButton edge="start" onClick={onToggleSidebar} sx={{ color: "#fff", mr: 1 }}>
            <MenuIcon />
          </IconButton>
        )}

        {title ? (
          <Typography variant="h6" sx={{ ml: 1, flexGrow: 1, fontWeight: "bold", color: "#fff" }}>
            {t(title)}
          </Typography>
        ) : (
          <Box sx={{ flexGrow: 1 }} />
        )}

        {rightSlot}
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
